<template>
    <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
    <div v-bind="attrs" v-on="on" >
    {{ item.label }}: <span style="font-weight: bold;">{{ item.value }}</span>
    </div>
    </template>
    <span :class="`${arabic?'arFont':'enFont'} pa-0`">
        {{ item.description }}
    </span>
    </v-tooltip>
</template>

<script>
import laguageMixins from '@/mixings/language';

export default {
  props: ['item'],
  mixins: [laguageMixins],
};
</script>

<style>

</style>
